import i18n from '../i18n';

// Axios' own message is "Request failed with status code 409": it tells the user nothing,
// while the server almost always says why in its body ("This email is already used...").
// Plugged as the last response interceptor of every axios instance, so any screen that
// shows `error.message` shows the real reason, without each form digging into
// `error.response`.
//
// Language: a response carrying a `code` is translated here, in the user's interface
// language (`apiErrors.<CODE>` in public/locales). That is the path to take for any error
// a user is expected to read. Without a code, the server's own text is shown as it was
// written, which is better than "status code 409" but not localised.
//
// - 4xx: `message`, else `error` — both are explanations the route chose to send.
// - 5xx: `message` only. `error` there is usually a raw exception ("E11000 duplicate
//   key...", "Cast to ObjectId failed") that would confuse more than it explains.
// - No response (network down, timeout): axios' message is kept, it is already right.
export const withServerMessage = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  if (status && data && typeof data === 'object') {
    const key = typeof data.code === 'string' ? `apiErrors.${data.code}` : null;
    const translated = key && i18n.exists(key) ? i18n.t(key) : null;
    const reason = translated || (status >= 500 ? data.message : (data.message || data.error));
    if (typeof reason === 'string' && reason.trim()) {
      error.axiosMessage = error.message; // kept for logs and debugging
      error.message = reason.trim();
    }
  }
  return Promise.reject(error);
};
